import React from 'react';


export interface ConfigContextInterface extends Record<string, string> {

}


const ROOT_PATH = process.env.PUBLIC_URL;
const ROOT_API = `${ROOT_PATH}/api`;

const defaultContext: ConfigContextInterface = {
    apiRoot: `${ROOT_API}`,
    usersPath: `${ROOT_API}/users`,
    userPath: `${ROOT_API}/user`,
    resultsPath: `${ROOT_API}/results`
};

export const ConfigContext =
    React.createContext<ConfigContextInterface>({...defaultContext});

interface ConfigurationStoreInterface {
    conf: ConfigContextInterface;
}


export const ConfigurationStore: React.FC<ConfigurationStoreInterface> = (props) => {
    return (
        <ConfigContext.Provider value={{...props.conf}}>{props.children}</ConfigContext.Provider>
    )
};
